<template>
  <div class="animated fadeIn">
    <b-row
      align-h="center"
      class="text-leftr"
    >
      <b-col md="12">
        <h4>렘넌트 추천서</h4><hr>
      </b-col>
    </b-row>
    <b-row
      align-h="start"
      class="text-leftr"
    >
      <b-col
        v-if="longterm == 0"
        md="2"
      >
        <b-form-group
          name="rankSet"
          :label="'순위'"
          label-for="rank"
        >
          <b-form-input
            :id="'rank'"
            v-model="rank"
            :disabled="freezing"
            type="number"
          />
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group
          v-show="$store.getters.isSuper"
          name="titleSet"
          :label="'장학금 종류'"
          label-for="title"
        >
          <b-form-select
            v-model="donateId"
            :disabled="freezing"
            :options="titleOptions"
            class="mb-3"
            :state="donateId !== ''"
            @change="updateAmount"
          />
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group
          v-show="$store.getters.isSuper"
          name="finalAmountSet"
          :label="'금액'"
          label-for="finalAmount"
        >
          <b-form-input
            id="finalAmount"
            v-model="finalAmount"
            v-validate.initial="veeNumber"
            name="finalAmount"
            :state="!errors.has('finalAmount')"
            :disabled="freezing"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <b-form-group
          v-show="$store.getters.isSuper || $store.getters.isReader"
          name="schlRewviewSet"
          :label="'장학국 의견'"
          label-for="schlReview"
        >
          <b-form-textarea
            id="schlReview"
            v-model="schlReview"
            :disabled="freezing"
            :rows="2"
            :max-rows="2"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-if="longterm == 0">
      <b-col md="12">
        <b-form-group
          name="partRewviewSet"
          :label="'부서 추천서(사소한 것 하나까지 상세하게 서술 해 주세요)'"
          label-for="partReview"
        >
          <b-form-textarea
            id="partReview"
            v-model="partReview"
            :disabled="freezing"
            :rows="5"
            :max-rows="5"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <b-button
          v-show="!freezing"
          :disabled="errors.has('finalAmount') || applyId === ''"
          class="mb-5"
          variant="primary"
          size="sm"
          block
          @click="updateReview()"
        >
          <b>추천서 저장</b>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import api from '../../api'

export default {
  name: 'ApplyReview',
  props: {
    email: {
      type: String,
      required: true
    },
    applyId: {
      type: String,
      required: true
    },
    part: {
      type: String,
      required: false,
      default: ''
    },
    readOnly: {
      type: Boolean,
      required: true
    },
    longterm: {
      type: Number,
      default: 0
    },
    reviewId: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      partReview: '',
      schlReview: '',
      rank: -1,
      donateId: '미선정:0',
      titleOptions: api.defaultTitleList(this.part),
      finalAmount: 0,
      amountMap: {},
      veeNumber: {
        required: true,
        regex: /^(\d+)$/
      }
    }
  },
  computed: {
    freezing () {
      return this.readOnly
    }
  },
  watch: {
    applyId: function (val) {
      this.getDetailInfo(1)
    }
  },
  mounted () {
    if (this.email !== '' && this.applyId !== '') {
      this.getDetailInfo(1)
    }
  },
  methods: {
    updateAmount (val) {
      if (val) {
        this.finalAmount = val.split(':')[1]
      }
    },
    title () {
      var result = '미선정'
      this.titleOptions.forEach(title => {
        if (this.donateId === title.value) {
          result = title.text.split(':')[0]
        }
      })
      return result
    },
    alertNotFound () {
      alert('등록된 정보가 없습니다!')
    },
    updateReview () {
      // post arg 세팅
      var postArg = {}
      postArg['reviewId'] = this.reviewId === '' ? api.docId('review', this.email) : this.reviewId
      postArg['applyId'] = this.applyId
      postArg['email'] = this.email
      postArg['partReview'] = this.partReview
      postArg['schlReview'] = this.schlReview
      postArg['rank'] = this.rank
      postArg['donateId'] = this.donateId.split(':')[0]
      postArg['title'] = this.title()
      postArg['modifiedDate'] = api.currentUnixTime()
      postArg['amount'] = Number(this.finalAmount)

      /* file 처리 성공하고 돌아온 file명들을 문서에 넣는다. */
      api.request('post', '/admin/review/save', postArg)
        .then(response => {
          var data = response.data
          /* 200 이면  data에 바로 doc정보가 있거나, data.error가 있음
             400 이면 erros.response.data.error */
          if (data.error) {
            this.alertFail(data.error)
          } else {
            this.alertSuccess()
            this.$emit('reviewUpdated', '')
          }
        })
        .catch(error => {
          this.alertFail(error.response.data.error)
        })
    },
    alertSuccess () {
      alert('리뷰 완료!')
    },
    alertFail (msg) {
      alert(msg)
    },
    parseDetailInfo (data) {
      let docs = data.docs
      let titles = data.titles
      if (docs.length === 0) {
        this.partReview = ''
        this.schlReview = ''
        this.rank = -1
        this.finalAmount = 0
        this.donateId = '미선정:0'
      } else if (docs.length === 1) {
        this.partReview = docs[0].partReview
        this.schlReview = docs[0].schlReview
        this.rank = docs[0].rank
        this.finalAmount = docs[0].amount /* number */
        // auth === 0 이 아니면 docs[0].donateId 는 빈값
        if (docs[0].donateId !== '') {
          this.donateId = docs[0].donateId + ':' + String(this.finalAmount)
        } else {
          this.donateId = '미선정:0'
        }
      } else if (docs.length > 1) {
        this.alertFail('review 문서가 어러개. 문제 있음!')
      }
      this.titleOptions = api.defaultTitleList(this.part)
      titles.forEach(title => {
        this.titleOptions.push({ 'value': title[0] + ':' + String(title[2]), 'text': title[1] })
      })
    },
    getDetailInfo (info) {
      if (this.errors.has('email')) {
        this.alertRetryEmail()
        return
      }
      api.request('get', '/admin/review?' + 'applyId=' + this.applyId + '&info=1&cnt=1')
        .then(response => {
          var data = response.data
          if (data.error) {
            this.alertFail(data.error)
            return
          }
          this.parseDetailInfo(data)
        })
        .catch(error => {
          console.log(error.response)
        })
      this.$validator.reset()
    }
  }
}
</script>

<style>
</style>
